import { Button, Grid, Typography } from '@mui/material';
import TrashRedIcon from 'assets/icons/buttons/trash-button.svg';
import { styles } from './styles';

interface IDeleteButton {
  text: string;
  fullWidth?: boolean;
  onClick: () => void;
}

export const DeleteButton = ({ text, fullWidth, onClick }: IDeleteButton) => {
  return (
    <Grid sx={[fullWidth && styles.fullWidth]}>
      <Button
        type="button"
        disableRipple
        disableElevation
        fullWidth={fullWidth}
        sx={styles.button}
        onClick={onClick}
      >
        <Grid sx={styles.grid}>
          <TrashRedIcon />
          <Typography className="delete-button-text" textTransform="capitalize" sx={styles.text}>
            {text}
          </Typography>
        </Grid>
      </Button>
    </Grid>
  );
};
